import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { editCertificate, getCertificateById } from "../../../../redux/features/certificate/certificateService";
import { showToast } from "../../../../components/ToastMsg";
import { faCircleCheck, faDownload } from "@fortawesome/free-solid-svg-icons";
import { selectAllActivityLogByCertificate, STATUS } from "../../../../redux/features/activityLog/activityLogSlice";
import { downloadAllActivityLogsByCertificate, getAllActivityLogsByCertificate } from "../../../../redux/features/activityLog/activityLogService";
import Timeline from "../../../../components/Timeline";
import TimelineSkeleton from "../../../../components/Skeleton/TimelineSkeleton";
import styles from './index.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CertificateActivityLogs = () => {
    const { certificate_id } = useParams();
    const dispatch = useDispatch();

    const { isLoadingCertificateDetails, isCertificateDetailsSuccess, certificate } = useSelector((state) => state.certificate.certificateDetails);
    const { data: certificateActivityLogs, status } = useSelector(selectAllActivityLogByCertificate);

    useEffect(() => {
        if (!certificate_id) return;

        dispatch(getCertificateById({ certificate_id }));
    }, [dispatch, certificate_id]);

    useEffect(() => {
        if (!certificate_id) return;

        dispatch(getAllActivityLogsByCertificate({ certificate_id }));
    }, [dispatch, certificate_id]);

    const downloadActivityLog = async () => {
        try {
            const params = {
                certificate_id: certificate_id,
                doc_ref: certificate.document_ref,
            };
            await dispatch(downloadAllActivityLogsByCertificate(params)).unwrap()
        } catch (error) {
            showToast('error', 'Failed to download the file.')
        }
    }

    return (
        <>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Certificate Activity Logs
                    <FontAwesomeIcon icon={faDownload} onClick={downloadActivityLog} className={styles.downloadBtn} />
                </h1>
                <div className={styles.cardSec}>
                    <>
                        {(status === STATUS.IDLE || status === STATUS.LOADING) && (
                            <TimelineSkeleton />
                        )}
                        {status === STATUS.FAILED && (
                            <div className="error-text">
                                Failed to load activity logs
                            </div>
                        )}
                        {status === STATUS.SUCCEEDED && certificateActivityLogs.data.length === 0 && (
                            <div>No activity logs found</div>
                        )}
                        {status === STATUS.SUCCEEDED && certificateActivityLogs.data.length > 0 && (
                            <Timeline data={certificateActivityLogs} />
                        )}
                    </>
                </div>
            </div>
        </>
    );
};
export default CertificateActivityLogs;
